import Collection from "../../../web/components/common/Collection";
import { Footer } from "../../../web/components/footer";
import { Header } from "../../../web/components/header";
import { Sidebar } from "../../../web/components/sidebar";
import React from "react";
import "./../../../../app/pages/Home/Home.page.scss";

const MainContainer: React.FC<any> = (props: any) => {

  return (
    <div className="sni-main-wrapper">
      <Header {...props} />
      <Sidebar {...props} />
      <Footer {...props} />
      <Collection {...props}/>
    </div>
  );
}

export default React.memo(MainContainer);
